var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.856L1.283 6.112a.37.37 0 0 0-.53 0 .385.385 0 0 0 0 .538L3 8.933V9h.066l.312.317a.37.37 0 0 0 .53 0L6.533 6.65a.385.385 0 0 0 0-.538.37.37 0 0 0-.53 0L4 8.146V0H3v7.856z",
    fillRule: "nonzero",
    fill: "#841D64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort-down.514ed77361e91361d61a639058a03d80.svg";
export { ForwardRef as ReactComponent };